import { render, staticRenderFns } from "./TypographyDisplay.vue?vue&type=template&id=ddf4ab20&"
import script from "./TypographyDisplay.vue?vue&type=script&lang=js&"
export * from "./TypographyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports